// libraries
import React, { useState, useEffect } from 'react'

// components
import Section from '/react4xp/components/Section'
import RichText from '/react4xp/components/RichText'
import Button from '/react4xp/components/Button'
import Image from '/react4xp/components/Image'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// types
interface ListProductsProps {
	title?: string
	description?: string
	products?: Array<{
		src?: string
		alt?: string
		title?: string
		href?: string
		tag?: string
	}>
	howManyItems?: number
	bottomButtonText?: string
}

export default function ListProducts({
	title,
	description,
	products = [],
	howManyItems = 6,
	bottomButtonText
}: ListProductsProps) {

	const [visibleProducts, setVisibleProducts] = useState(howManyItems)

	const loadMoreProducts = () => {
		setVisibleProducts(prevVisibleProducts => {
			return Math.min(prevVisibleProducts + howManyItems, products.length)
		})
	}

	useEffect(() => {
		setVisibleProducts(Math.min(howManyItems, products.length))
	}, [howManyItems, products.length])

	return (
		<Section className='list-products'>
			<div className='container'>

				{(isNonWhitespaceString(title) || isNonWhitespaceString(description)) && (
					<div className='row'>
						<div className='col-lg-6 col-lg-push-3 list-products__top'>

							{isNonWhitespaceString(title) && (
								<h2 className='h1-hero-big list-products__title'>
									{title}
								</h2>
							)}

							{isNonWhitespaceString(description) && (
								<RichText
									content={description}
									className='list-products__description'
								/>
							)}

						</div>
					</div>
				)}

				<div className='list-products__grid'>
					{products.slice(0, visibleProducts).map((product, i) => (
						<a
							key={i}
							href={product.href}
							className='list-products__item'
						>

							<div className='list-products__item-image'>

								<Image
									src={product.src} // 400px x 400px
									alt={product.alt}
									width={400}
									sizes='(max-width: 768px) 100vw, 500px'
								/>

								{product.tag && (
									<div className='list-products__item-tag text-smaller semi-bold'>
										{product.tag}
									</div>
								)}

							</div>

							<p className='list-products__item-title text-big'>
								{product.title}
							</p>

						</a>
					))}
				</div>

				{bottomButtonText && visibleProducts < products.length && (
					<div className='list-products__load-more'>
						<Button
							onClick={loadMoreProducts}
							noUnderline
						>
							{bottomButtonText}
						</Button>
					</div>
				)}

			</div>
		</Section>
	)
}